import React, { useState, useEffect } from "react";
import { Button, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import StepperComponent from "../Stepper/Stepper";
import "./PageEnd.css";
import moment from "moment";
import QRCode from "qrcode.react";
import ServiceMesRdv from "../MesRdv/ServiceMesRdv/ServiceMesRdv";
//Print data
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import logo from "../../image/logo2.png";

const PrintRdv = (props) => {
  useEffect(() => {
    getDataRdv();
  }, []);

  const [Infos, setInfos] = useState([]);

  const user = {
    id: JSON.parse(sessionStorage.getItem("user")).id,
    firstName: JSON.parse(sessionStorage.getItem("user")).firstName,
    lastName: JSON.parse(sessionStorage.getItem("user")).lastName,
    username: JSON.parse(sessionStorage.getItem("user")).username,
    cin: JSON.parse(sessionStorage.getItem("user")).cin,
  };

  // const analyse = {
  //   id: JSON.parse(localStorage.getItem("analyse")).id,
  //   designation: JSON.parse(localStorage.getItem("analyse")).designation,
  //   price: JSON.parse(localStorage.getItem("analyse")).price,
  //   type: JSON.parse(localStorage.getItem("analyse")).type,
  // };

  const idFromStore = JSON.parse(sessionStorage.getItem("idRdv")).id;

  const info = {};
  const getDataRdv = () => {
    ServiceMesRdv.getRdvById(idFromStore).then((res) => {
      // const printData = res.data.filter((x) => x.id === idFromStore);
      setInfos(res.data);
    });
  };

  const printData = () => {
    const input = document.getElementById("all");

    html2canvas(input).then((canvas) => {
      var imgData = canvas.toDataURL("image/png");
      var imgWidth = 220;
      var pageHeight = 350;
      var imgHeight = (canvas.height * imgWidth) / canvas.width;
      var heightLeft = imgHeight;
      var position = 40;
      var mainLogo = logo;

      var pdf = new jsPDF("p", "mm", "a4");
      //logo
      if (mainLogo) {
        pdf.addImage(mainLogo, "JPEG", 10, 3, 25, 15);
      }
      // image content
      pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight + 10);
      heightLeft -= pageHeight;

      // pdf header
      pdf.setTextColor(0, 0, 0);
      pdf.text("Prise de rendez-vous en ligne", 70, 30);
      pdf.setFontSize(9);

      //pdf titile
      pdf.setProperties({
        title: "rendez-vous.pdf",
      });
      window.open(pdf.output("bloburl", "confirmation.pdf"));
    });
  };
  const qrData = [];
  // `[ Nom complet : ${user.firstName} ${user.lastName}, CIN : ${user.cin}, Analyse : ${Infos.analyse.designation}, prix : ${Infos.analyse.price}]`;
  // console.log("this is infos data: ", Infos.analyse.price);
  const labo = JSON.parse(sessionStorage.getItem("Laboratory"));

  return (
    <>
      <div className="pageend container" id="data">
        <h2>Prise de rendez-vous en ligne</h2>
        <hr />
        {/* <StepperComponent activeStep={activeStep} /> */}
        <div className="pb-4" id="all">
          <Row>
            <Col lg={8}>
              <h5>Merci de votre confiance</h5>
              <p>
                Votre rendez-vous est réservé. Votre numéro de référence est le{" "}
                <strong>{user.cin} </strong> .<br />
                <strong>
                  IMPORTANT - Vous devez présenter votre ordonnance médicale et
                  la carte d'identité au moment du rendez-vous
                </strong>
              </p>
              <p>
                Pour modifier ou annuler ce rendez-vous, contactez-nous par
                télèphone au{" "}
                <span style={{ fontWeight: "700", color: "#2ecc71" }}>
                  0522 22 22 22
                </span>
                .
              </p>
            </Col>
          </Row>

          <div className="pb-3">
            <Row>
              <Col lg={7}>
                <div className="d-inline-flex">
                  <div className="card1">
                    {Infos.length && (
                      <ul className="pl-3">
                        <li>
                          Patient :
                          <strong>
                            {" "}
                            {user.firstName} {user.lastName}
                          </strong>
                        </li>

                        <li>
                          Analyse :{" "}
                          <strong> {Infos.analyse.designation}</strong>
                        </li>
                        <li>
                          Type : <strong> Sur laboratoire</strong>
                        </li>
                        <li>
                          Prix estimé :{" "}
                          <strong>{Infos.analyse.price} DH</strong>
                        </li>
                        <li>
                          Date :{" "}
                          <strong>
                            {`Le ${moment(Infos.dateform).format(
                              "DD/MM/YYYY"
                            )} à ${Infos.hour}`}
                          </strong>
                        </li>
                      </ul>
                    )}
                  </div>
                  <div className="card2">
                    <h5>Nos services sont remboursés, n'attendez pas.</h5>
                    <p>
                      Nos services sont remboursés par la plupart des régimes
                      d'assurance collectives et privées. Renseignez-vous auprès
                      de votre assureur.
                    </p>
                  </div>
                </div>
              </Col>
              <Col lg={5}>
                <QRCode
                  id={`${user.cin}`}
                  value={`${qrData}`}
                  size={180}
                  level={"H"}
                  includeMargin={true}
                />
              </Col>
            </Row>
          </div>
        </div>
        <Row>
          <Col lg={3}>
            <p>* Prix sujet ‡ confirmation lors de votre rendez-vous</p>
          </Col>
          <Col lg={6}>
            <div className="card">
              <h4>Vous avez des questions?</h4>
              <p>
                N'hésitez pas à contacter le numéro{" "}
                <span
                  style={{
                    fontWeight: "700",
                    color: "#2ecc71",
                  }}
                >
                  {labo && labo.tel}
                </span>
                . Du lundi au vendredi de 9 h à 18 h et samedi de 9 h et 13 h.
              </p>
            </div>
          </Col>

          <Col lg={3}>
            <Button onClick={printData}>Imprimer la confirmation</Button>
            <Link to="/">
              <Button>
                &thinsp; &thinsp; Retourner ‡ l'accueil &thinsp; &thinsp;
              </Button>
            </Link>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default PrintRdv;
